import React, {useState} from 'react'
import { Table, Button,Collapse } from 'antd';
import { useDispatch } from 'react-redux';
import { DisplayDate } from '../../../../components/_utils/appUtils';
import { SelectAbstractReviewer } from '../reviewer/SelectAbstractReviewer'
import SelectReceiveDateDrawer from '../abstractPages/SelectReceiveDateDrawer';
import { chooseEmailModalFxn } from '../../../../components/_utils/appUtils';
import AbstractAddRemarkDrawer from '../abstractPages/AbstractAddRemarkDrawer';
import MemberHistory from '../../../../containers/article/reviewer/memberHistory'
import {ResendAbstract} from '../../views/actions'
const { Panel } = Collapse

export const ReviewerDetails = ({ abstract,onRefresh }) => {
  const [visibleSelectReview, setVisibleSelectReview] = useState(false);
  const [receiveDateDrawerVisible, setReceiveDateDrawerVisible] = useState(false);
  const [addRemarkDrawerVisible, setAddRemarkDrawerVisible] = useState(false);
  const [memberDrawerVisible, setMemberDrawerVisible] = useState(false);

  const [reviewerId, setReviewerId] = useState('');
  const [reviewerData, setReviewerData] = useState({});
  // console.log("Full Reviewer Object:", abstract.selectedReviewer[0]);
  // const events = {
  //   showAndHideReceiveDate: (value, id = '') => { setReceiveDateDrawerVisible(value); setReviewerId(id); },
  //   showAndHideAddRemarkDrawer: (value, id = '') => { setAddRemarkDrawerVisible(value); setReviewerId(id); },
  //   showMemberHistory: (record) => { setMemberDrawerVisible(true); setReviewerData(record.reviewerId); setReviewerId(record.reviewerId._id); }
  //   resendAbstract: (reviewerId) => {
  //     chooseEmailModalFxn({
  //       title: 'Resend Abstract',
  //       callback: async (email) => {
  //         let obj = {
  //           abstractId: abstract._id,
  //           reviewerId: reviewerId,
  //           fromEmail: email,
  //           template: 'requestToNewReviewer' // Ensure this template exists in your backend
  //         };
  //
  //         let resp = await dispatch(ResendAbstract(obj));
  //
  //         if (resp && resp.success) {
  //           // Optional: Add success notification or refresh logic
  //           console.log("Abstract resent successfully");
  //         }
  //       }
  //     });
  //   }
  // };
  const dispatch = useDispatch();
  const events = {
    showAndHideReceiveDate: (value, id = '') => { setReceiveDateDrawerVisible(value); setReviewerId(id); },
    showAndHideAddRemarkDrawer: (value, id = '') => { setAddRemarkDrawerVisible(value); setReviewerId(id); },
    showMemberHistory: (record) => { setMemberDrawerVisible(true); setReviewerData(record.reviewerId); setReviewerId(record.reviewerId._id); },

    resendAbstract: (reviewerId) => {
      chooseEmailModalFxn({
        title: 'Resend Abstract',
        callback: async (email) => {
          let obj = {
            abstractId: abstract._id,
            reviewerId: reviewerId,
            fromEmail: email,
            template: 'requestToNewReviewerAbstract'
          };

          let resp = await dispatch(ResendAbstract(obj));

          if (resp && resp.success) {
            dispatch({ type: 'START_LOAD_ABSTRACT' });
          }
        }
      });
    }
  };
  const columns = [
    { title: 'Reviewer ID', dataIndex: ['reviewerId', 'reviewerId'] },
    { title: 'Name', dataIndex: ['reviewerId', 'name'] },
    { title: 'Rating', dataIndex: ['reviewerId', 'rating'] },
    { title: 'Send Date', dataIndex: 'assignedDate', render: d => DisplayDate(d) },
    { title: 'Reminder Date', dataIndex: 'reminderDate', render: d => DisplayDate(d) },
    // { title: 'Remark', dataIndex: 'remarks' },
    {
      title: 'Remark',
      dataIndex: 'remarks',
      render: (text) => (text ? text : '')
    },
    {
      title: 'Remark Date',
      dataIndex: 'commentsDate',
      render: (d, record) => (record.remarks ? DisplayDate(d) : '')
    },
    {
      title: 'Received Date',
      dataIndex: 'receiveDate',
      render: d => (d ? DisplayDate(d) : '')
    },

    // { title: 'Action', render: () => <Button size="small">View History</Button> }
    // {
    //   title: 'Action',
    //   key: 'actions',
    //   width: 250,
    //   render: (val, record) => {
    //     let { reviewerId } = record;
    //     return (
    //       <React.Fragment>
    //         {/* Only show "Receive Date" if it's not already received */}
    //         {!record.receiveDate ? (
    //           <Button
    //             className={'roundSmallBtn'}
    //             size="small"
    //             onClick={() => events.showAndHideReceiveDate(true, reviewerId._id)}
    //           >
    //             Receive Date
    //           </Button>
    //         ) : null}
    //
    //         <Button
    //           className={'roundSmallBtn'}
    //           size="small"
    //           onClick={() => events.showAndHideAddRemarkDrawer(true, reviewerId._id)}
    //         >
    //           Remarks
    //         </Button>
    //
    //         <Button
    //           className={'roundSmallBtn'}
    //           size="small"
    //           onClick={() => events.showMemberHistory(record)}
    //         >
    //           View History
    //         </Button>
    //       </React.Fragment>
    //     )
    //   }
    // }
    // Inside your columns array:
    // {
    //   title: 'Action',
    //   key: 'actions',
    //   width: 280,
    //   render: (val, record) => {
    //     let { reviewerId ,remarks,receiveDate} = record;
    //     const isCompleted = !!remarks;
    //     const hasReceiveDate = !!(record.receiveDate && record.receiveDate !== '');
    //     return (
    //       <React.Fragment>
    //         {/* Row 1: Main Actions */}
    //         <div style={{ marginBottom: 5 }}>
    //           {/*{!record.receiveDate && (*/}
    //           {/*  <Button className={'roundSmallBtn'} onClick={() => events.showAndHideReceiveDate(true, reviewerId._id)}>*/}
    //           {/*    Receive Date*/}
    //           {/*  </Button>*/}
    //           {/*)}*/}
    //           {!hasReceiveDate && (
    //             <Button className={'roundSmallBtn'} onClick={() => events.showAndHideReceiveDate(true, reviewerId._id)}>
    //               Receive Date
    //             </Button>
    //           )}
    //           {/*<Button className={'roundSmallBtn'} onClick={() => events.showAndHideAddRemarkDrawer(true, reviewerId._id)}>*/}
    //           {/*  Remarks*/}
    //           {/*</Button>*/}
    //           {hasReceiveDate && !isCompleted && (
    //             <Button className={'roundSmallBtn'} onClick={() => events.showAndHideAddRemarkDrawer(true, reviewerId._id)}>
    //               Remarks
    //             </Button>
    //           )}
    //         </div>
    //         <div>
    //           <Button className={'roundSmallBtn'} onClick={() => events.showMemberHistory(record)}>
    //             View History
    //           </Button>
    //           {/*<Button className={'roundSmallBtn'} onClick={() => events.resendAbstract(reviewerId._id)}>*/}
    //           {/*  Resend Abstract*/}
    //           {/*</Button>*/}
    //           {!isCompleted && (
    //             <Button className={'roundSmallBtn'} onClick={() => events.resendAbstract(reviewerId._id)}>
    //               Resend Abstract
    //             </Button>
    //           )}
    //         </div>
    //       </React.Fragment>
    //     );
    //   }
    // }
    {
      title: 'Action',
      key: 'actions',
      width: 280,
      render: (val, record) => {
        // Bulletproof checks to see what data actually exists
        const hasReceiveDate = !!record.receiveDate && record.receiveDate !== '';
        const hasRemarks = !!record.remarks && record.remarks.trim() !== '' && record.remarks !== '<p></p>';

        return (
          <React.Fragment>
            <div style={{ marginBottom: 5 }}>

              {/* RECEIVE DATE BUTTON */}
              {/* Rule: Hide if remarks exist. Hide if receive date already exists. */}
              {!hasReceiveDate && !hasRemarks && (
                <Button
                  className={'roundSmallBtn'}
                  onClick={() => events.showAndHideReceiveDate(true, record.reviewerId._id)}
                >
                  Receive Date
                </Button>
              )}

              {/* REMARKS BUTTON */}
              {/* Rule: Hide if receive date exists. Hide if remarks already exist. */}
              {!hasRemarks && !hasReceiveDate && (
                <Button
                  className={'roundSmallBtn'}
                  onClick={() => events.showAndHideAddRemarkDrawer(true, record.reviewerId._id)}
                >
                  Remarks
                </Button>
              )}

            </div>

            <div>
              <Button
                className={'roundSmallBtn'}
                onClick={() => events.showMemberHistory(record)}
              >
                View History
              </Button>
              {!hasRemarks && (
                <Button
                  className={'roundSmallBtn'}
                  onClick={() => events.resendAbstract(record.reviewerId._id)}
                >
                  Resend Abstract
                </Button>
              )}
            </div>
          </React.Fragment>
        );
      }
    }  ];
  // const getExtraButton = () => (
  //   <Button
  //     type={'primary'}
  //     size={'small'}
  //     onClick={(e) => {
  //       e.stopPropagation();
  //       setVisibleSelectReview(true);
  //     }}
  //   >
  //     Select Reviewer
  //   </Button>
  // );
  const getExtraButton = () => {
    return (
      // <React.Fragment>
      //   {/* Show "Select Reviewer" only when the status is 'Abstract Under Review' */}
      //   {abstract.status === 'Abstract Under Review' ? (
      //     <Button
      //       type={'primary'}
      //       size={'small'}
      //       onClick={(e) => {
      //         e.stopPropagation();
      //         setVisibleSelectReview(true);
      //       }}
      //     >
      //       Select Another Reviewer
      //     </Button>
      //   ) : null}
      //
      //   {/* Show "Select Another Reviewer" if the status is NOT 'Abstract Under Review' */}
      //   {/*{abstract.status !== 'Abstract Under Review' ? (*/}
      //   {/*  <Button*/}
      //   {/*    type={'primary'}*/}
      //   {/*    size={'small'}*/}
      //   {/*    onClick={(e) => {*/}
      //   {/*      e.stopPropagation();*/}
      //   {/*      setVisibleSelectReview(true);*/}
      //   {/*    }}*/}
      //   {/*  >*/}
      //   {/*    Select Another Reviewer*/}
      //   {/*  </Button>*/}
      //   {/*) : null}*/}
      // </React.Fragment>
      <React.Fragment>
        {/* If status is 'Submitted Abstract', show "Select Reviewer" */}
        {abstract.status === 'Submitted Abstract' ? (
          <Button
            type={'primary'}
            size={'small'}
            onClick={(e) => {
              e.stopPropagation();
              setVisibleSelectReview(true);
            }}
          >
            Select Reviewer
          </Button>
        ) : abstract.status === 'Abstract Under Review' ? (
          /* If status is 'Abstract Under Review', show "Select Another Reviewer" */
          <Button
            type={'primary'}
            size={'small'}
            onClick={(e) => {
              e.stopPropagation();
              setVisibleSelectReview(true);
            }}
          >
            Select Another Reviewer
          </Button>
        ) : null}
      </React.Fragment>
    );
  };
  return (
    <div>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
        <Panel header="Under Review" key="1" extra={getExtraButton()}>
          <Table
            dataSource={abstract.selectedReviewer || []}
            columns={columns}
            pagination={false}
            bordered
            size="small"
          />
        </Panel>
      </Collapse>

      <SelectAbstractReviewer
        abstract={abstract}
        ids={abstract.selectedReviewer ? abstract.selectedReviewer.reduce((acc, r) => ({...acc, [r.reviewerId._id]: true}), {}) : {}}
        onClose={() => setVisibleSelectReview(false)}
        visible={visibleSelectReview}
        page={'abstractView'}
      />
      {/*{receiveDateDrawerVisible && (*/}
      {/*  <SelectReceiveDateDrawer*/}
      {/*    visible={receiveDateDrawerVisible}*/}
      {/*    reviewerId={reviewerId}*/}
      {/*    abstract={abstract}*/}
      {/*    onClose={() => setReceiveDateDrawerVisible(false)}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{receiveDateDrawerVisible && (*/}
      {/*  <SelectReceiveDateDrawer*/}
      {/*    visible={receiveDateDrawerVisible}*/}
      {/*    reviewerId={reviewerId}*/}
      {/*    abstract={abstract}*/}
      {/*    onClose={() => {*/}
      {/*      setReceiveDateDrawerVisible(false);*/}
      {/*      if (onRefresh) onRefresh();*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}
      {receiveDateDrawerVisible && (
        <SelectReceiveDateDrawer
          visible={receiveDateDrawerVisible}
          reviewerId={reviewerId}
          abstract={abstract}
          onClose={() => {
            setReceiveDateDrawerVisible(false);
            // Hard reload to completely bypass the freeze
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }}
        />
      )}
      {memberDrawerVisible && (
        <MemberHistory
          visible={memberDrawerVisible}
          reviewerId={reviewerId}
          data={reviewerData}
          onClose={() => setMemberDrawerVisible(false)}
        />
      )}
      {/*{addRemarkDrawerVisible && (*/}
      {/*  <AbstractAddRemarkDrawer*/}
      {/*    visible={addRemarkDrawerVisible}*/}
      {/*    reviewerId={reviewerId}*/}
      {/*    abstract={abstract}*/}
      {/*    onClose={() => setAddRemarkDrawerVisible(false)}*/}
      {/*  />*/}
      {/*)}*/}
      {addRemarkDrawerVisible && (
        <AbstractAddRemarkDrawer
          visible={addRemarkDrawerVisible}
          reviewerId={reviewerId}
          abstract={abstract}
          onClose={() => {
            setAddRemarkDrawerVisible(false);
            if (onRefresh) onRefresh();
          }}
        />
      )}
    </div>
  );
};
